import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { WEBHOOKS } from "../lib/webhooks";

function EmptyState({ title, body, ctaLabel, onCta, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-2xl border border-white/10 px-8 py-16 text-center"
      data-testid={testId}
    >
      <h3 className="text-lg mb-2">{title}</h3>
      <p className="text-sm opacity-70 mb-4">{body}</p>

      {onCta && (
        <button onClick={onCta} className="text-cyan-400">
          {ctaLabel} →
        </button>
      )}
    </motion.div>
  );
}

export function Galeria({ user, onNeedAuth, onLaunch }) {
  const [galleryItems, setGalleryItems] = useState([]); // 🔥 SOLO BD
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const PREVIEW = 3;
  const canCollapse = galleryItems.length > PREVIEW;
  const visible =
    expanded || !canCollapse
      ? galleryItems
      : galleryItems.slice(0, PREVIEW);

  // 🔥 CARGA AUTOMÁTICA DESDE WEBHOOK
  const loadGallery = async () => {
    if (!user) return;

    setLoading(true);

    try {
      const res = await fetch(WEBHOOKS.gallery, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify({
          userId: user.id,
        }),
      });

      const data = await res.json();

      setGalleryItems(data.items || []);
    } catch (err) {
      console.error("Error cargando galería:", err);
    }

    setLoading(false);
  };

  // 🔥 AUTOLOAD CUANDO HAY USER
  useEffect(() => {
    if (user) {
      loadGallery();
    }
  }, [user]);

  const downloadImage = async (url, index) => {
    const secureUrl = url.replace("http://", "https://");

    try {
      const response = await fetch(secureUrl);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const blob = await response.blob();

      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `look-${index + 1}.jpg`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error descargando imagen:", error);
      window.open(secureUrl, "_blank");
    }
  };

  const isEmpty = galleryItems.length === 0;

  return (
    <section className="py-20">
      <div className="max-w-6xl mx-auto px-6">

        {/* HEADER */}
        <div className="flex items-center justify-between mb-6">
          <span className="text-xs font-mono opacity-60">
            § 005 · Galería · {galleryItems.length} looks
          </span>

          {user && (
            <button
              onClick={loadGallery}
              disabled={loading}
              className="text-xs font-mono"
            >
              {loading ? "Cargando..." : "Recargar ↻"}
            </button>
          )}
        </div>

        <h2 className="text-4xl mb-6">Tu colección.</h2>

        {user && canCollapse && (
          <button onClick={() => setExpanded(v => !v)} className="mb-4 text-xs">
            {expanded ? "Ver menos" : "Ver más"}
          </button>
        )}

        {/* CONTENIDO */}
        {!user ? (
          <EmptyState
            testId="guest"
            title="Inicia sesión"
            body="Tu galería es privada"
            ctaLabel="Entrar"
            onCta={onNeedAuth}
          />
        ) : isEmpty ? (
          <EmptyState
            testId="empty"
            title="Sin imágenes"
            body="Genera tu primer look"
            ctaLabel="Abrir studio"
            onCta={onLaunch}
          />
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {visible.map((it, i) => (
              <motion.div
                key={it.id || i}
                onClick={() => it.url && downloadImage(it.url, i)}
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                className="relative overflow-hidden rounded-xl cursor-pointer"
                style={{
                  aspectRatio:
                    it.format === "1:1"
                      ? "1/1"
                      : it.format === "9:16"
                      ? "9/16"
                      : "3/4",
                }}
              >
                {it.url ? (
                  <img
                    src={it.url}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                ) : (
                  <div className="absolute inset-0 grid place-items-center text-xs">
                    procesando
                  </div>
                )}

                <div className="absolute bottom-2 left-2 right-2 flex justify-between text-[10px] opacity-0 hover:opacity-100 bg-black/40 px-2 py-1 rounded">
                  <span>#{String(i + 1).padStart(3, "0")}</span>
                  <span>{it.model || "sd45"}</span>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}